import React from 'react';
import { Box, Text } from 'ink';
import { colors } from '../colors';

// Tanuki rasterised from the press SVG into Braille cells (2x4 sub-pixels each)
// so it stays smooth at this size. GLYPH = dot pattern; FG = colour key per cell.
const GLYPH: readonly string[] = [
  '⠀⠀⣰⣧⠀⠀⠀⠀⠀⠀⣼⣆⠀⠀',
  '⠀⢠⣿⣿⡆⣀⣀⣀⣀⢰⣿⣿⡄⠀',
  '⠀⣾⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣷⠀',
  '⠀⢿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⡿⠀',
  '⠀⠀⠙⠻⣿⣿⣿⣿⣿⣿⠟⠋⠀⠀',
  '⠀⠀⠀⠀⠈⠙⢿⡿⠋⠁⠀⠀⠀⠀',
];
const FG: readonly string[] = [
  '  RR      RR  ',
  ' RRRRRRRRRRRR ',
  ' ORRRRRRRRRRO ',
  ' OOOORRRROOOO ',
  '  OOOOYYOOOO  ',
  '    YYYYYY    ',
];

const COLOR: Record<string, string | undefined> = {
  R: colors.gitlabRed,
  O: colors.gitlabOrange,
  Y: colors.gitlabYellow,
  ' ': undefined,
};

// Merge consecutive cells of the same colour into one <Text> span.
const renderRow = (glyph: string, fg: string): React.ReactNode[] => {
  const spans: React.ReactNode[] = [];
  let i = 0;
  while (i < glyph.length) {
    const key = fg[i];
    let j = i;
    while (j < glyph.length && fg[j] === key) j += 1;
    spans.push(
      <Text key={i} color={COLOR[key]} bold>
        {glyph.slice(i, j)}
      </Text>,
    );
    i = j;
  }
  return spans;
};

export const GitLabLogo: React.FC = () => (
  <Box flexDirection="column">
    {GLYPH.map((glyph, i) => (
      <Text key={i}>{renderRow(glyph, FG[i])}</Text>
    ))}
  </Box>
);
